import { IApiRequestConfig } from '../api.types';

export const searchMeetingInfoApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'searchMeetingsInfo',
  uri: 'json',
  action: 'getAllMeetings',
  method: 'get',
});
